import React from "react";
import cn from "classnames";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { SimpleButton } from "components/buttons";
import { injectIntl } from "react-intl";
import { useImperativeTracking } from "components/tracking";
import { ExternalLink } from "components/link";
import styles from "./styles/web-announcer.css.js";
import withStyles from "components/with-styles";
import FormConfirm from "components/form/form-confirm";
import { isMobileOnly } from "react-device-detect";
import DataGrid, { DataGridItem } from "components/data-grid";

const WebAnnouncer = ({ intl, classes, event }) => {
  const track = useImperativeTracking();
  return event.urlRemoteLocution ? (
    <DataGrid>
      <DataGridItem big>
        <FormattedMessage id="event.dialog.webAnnouncer.description" />
      </DataGridItem>
      <DataGridItem big>
        {event.urlRemoteLocutionShort && (
          <ExternalLink className={classes.button} href={event.urlRemoteLocutionShort}>
            <div className={classes.alignedLink__externalLink__text}>{event.urlRemoteLocutionShort}</div>
          </ExternalLink>
        )}
      </DataGridItem>
      <DataGridItem big>
        <SimpleButton
          target={`remotelocution_${event.id}`}
          href={event.urlRemoteLocution}
          label={intl.formatMessage({ id: "event.dialog.webAnnouncer.button" })}
          rel="noopener noreferrer"
          className={cn({
            [classes.toolButton]: !isMobileOnly,
            [classes.toolButton_text__small]: isMobileOnly,
          })}
          onClick={e => {
            e.stopPropagation();
            track("access to remote locution url for event " + event.id);
          }}
        />
      </DataGridItem>
    </DataGrid>
  ) : (
    <DataGrid>
      <DataGridItem big>
        <FormattedMessage id="event.dialog.webAnnouncer.description.deactivated" />
      </DataGridItem>
      <DataGridItem big>
        <FormConfirm
          show
          label={intl.formatMessage({ id: "event.dialog.webAnnouncer.warning.deactivated" })}
          warning
          className={classes.warning}
          hideCloseButton
        />
      </DataGridItem>
    </DataGrid>
  );
};

WebAnnouncer.propTypes = {
  /**
   * Evento
   */
  event: PropTypes.object,
};

export default injectIntl(withStyles(styles)(WebAnnouncer));
